export const DESKTOP_PRODUCT_NAME = 'WebCatalog Desktop';
